// extracted by mini-css-extract-plugin
export default {"conteneur":"klemn_conteneur__6wxi8","conteneurTableMatieres":"klemn_conteneurTableMatieres__HeC4V","conteneurPage":"klemn_conteneurPage__VUMf3"};